module.exports = __webpack_public_path__ + "static/media/7_l_derevy1_9.74_71.02.528d6705.png";